import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import AppIcon from '../ui/AppIcon';
import { FaPlay, FaStar, FaUsers, FaMobile } from 'react-icons/fa';

const HomePage = () => {
  const { user } = useAuth();

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Nurture Your Inner Journey of 
                <span className="mindfulness-text"> Mindfulness</span>
              </h1>
              <p className="hero-subtitle">
                Discover the path to self-awareness through guided chapters, 
                interactive exercises, and personalized mindfulness practices.
              </p>
              <div className="hero-actions">
                {user ? (
                  <Link to="/chapters" className="btn btn-primary btn-large">
                    <FaPlay />
                    Continue Your Journey
                  </Link>
                ) : (
                  <>
                    <Link to="/signup" className="btn btn-primary btn-large">
                      Start Your Journey
                    </Link>
                    <Link to="/chapters" className="btn btn-outline btn-large">
                      Preview Chapters
                    </Link>
                  </>
                )}
              </div>
            </div>
            <div className="hero-visual">
              <AppIcon size={120} className="hero-icon" />
              <div className="floating-elements">
                <div className="floating-leaf"></div>
                <div className="floating-leaf"></div>
                <div className="floating-leaf"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Transform Your Inner World</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon mindfulness-gradient">
                <FaStar />
              </div>
              <h3>Guided Chapters</h3>
              <p>Step-by-step mindfulness content designed to guide you through your inner journey.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon mindfulness-gradient">
                <FaPlay />
              </div>
              <h3>Interactive Exercises</h3>
              <p>Practical exercises and reflections to deepen your understanding and practice.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon mindfulness-gradient">
                <FaUsers />
              </div>
              <h3>Personal Growth</h3>
              <p>Track your progress and build lasting mindfulness habits with our structured approach.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Tiers Preview */}
      <section className="content-preview">
        <div className="container">
          <h2 className="section-title">Choose Your Learning Path</h2>
          <div className="tiers-grid">
            <div className="tier-card">
              <h3>Free Access</h3>
              <ul>
                <li>Chapter previews and descriptions</li>
                <li>Introduction to mindfulness concepts</li>
                <li>Basic meditation guides</li>
              </ul>
              <Link to="/chapters" className="btn btn-outline">Explore Free Content</Link>
            </div>
            
            <div className="tier-card featured">
              <div className="featured-badge">Most Popular</div>
              <h3>Premium Access</h3>
              <ul>
                <li>Full chapter content</li>
                <li>Interactive exercises</li>
                <li>Answer explanations</li>
                <li>Progress tracking</li>
              </ul>
              <Link to="/subscription" className="btn btn-primary">Unlock Premium</Link>
            </div>
            
            <div className="tier-card">
              <h3>One-Time Purchase</h3>
              <ul>
                <li>Lifetime access to premium content</li>
                <li>No recurring charges</li>
                <li>Perfect for focused learning</li>
              </ul>
              <Link to="/subscription" className="btn btn-secondary">Buy Once</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <AppIcon size={60} />
            <h2>Ready to Begin Your Mindfulness Journey?</h2>
            <p>Join thousands of others discovering inner peace and self-awareness.</p>
            {!user && (
              <Link to="/signup" className="btn btn-primary btn-large">
                Get Started Free
              </Link>
            )}
            <div className="mobile-app-links">
              <p>Also available on mobile:</p>
              <div className="app-badges">
                <div className="app-badge">
                  <FaMobile />
                  <span>Download the App</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
